<template>
  <LoadingIndicatorComponent />
</template>

<script setup lang="ts">
import LoadingIndicatorComponent from "@/components/common/LoadingIndicatorComponent.vue";
import { onMounted } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();

onMounted(() => {
  // auth0-vue's plugin handles the code/state callback and navigates to the
  // original target (or "/"). We only need to bounce non-callback hits — direct
  // visits, malformed URLs, and error redirects (which carry no `code`).
  const params = new URLSearchParams(window.location.search);
  if (!params.has("code") || !params.has("state")) {
    router.replace("/");
  }
});
</script>
